import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';

const styles = theme => ({
  
});

class MaxWidthDialog extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'lg',
    canceledreceipt: []
  };

  canceledInvoice() {
    let context = this;
    $.ajax({
      type: 'POST', data: { 'type': context.props.type },
      url: Server() + 'receipt/getcancelreceipt.php',
      success: function(data) {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ open: true, canceledreceipt: data });
        } catch (e) { alert('Error'); }
      },
      error: function(e) {
        alert('Try again!!'); context.setState({ load: false });
      }
    });
  }

  makeDecimalPoint(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0.00;
    }
    return value;
  }

  render() {
    const { classes } = this.props;
    let i = 1;
    return (
      <React.Fragment>
        <Button color='primary' variant='outlined' onClick={this.canceledInvoice.bind(this)}>{this.props.name}</Button>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={ () => { this.setState({ open: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">{this.props.name}</DialogTitle>
          <DialogContent>
            <table id="table" width="100%">
              <tr>
                <th id="tableheader" style={{ width: '8%' }}><center>Sino</center></th>
                <th id="tableheader"><center>Transaction_id</center></th>
                <th id="tableheader"><center>Customer</center></th>
                <th id="tableheader"><center>Amount</center></th>
                <th id="tableheader"><center>Reason</center></th>
                <th id="tableheader"><center>Date & Time</center></th>
              </tr>
              {
                this.state.canceledreceipt.map((c) => {
                  let dateAndTime = c.timestamp;
                  let date;
                  let time;
                  try {
                    date = dateAndTime.split(' ')[0];
                    time = dateAndTime.split(' ')[1];
                    dateAndTime = date.split('-')[2]+"-"+date.split('-')[1]+"-"+date.split('-')[0]+" "+time;
                  } catch (e) {
                  }
                  let amount = c.amount;
                  if (amount < 0) { amount = amount * -1; }
                  else { amount = amount * 1; }
                  return (
                    <tbody>
                      <tr>
                        <td><center>{i++}</center></td>
                        <td><center>{c.transaction_id}</center></td>
                        <td>{c.name}</td>
                        <td><div style={{textAlign: 'right'}}>{this.makeDecimalPoint(amount)}</div></td>
                        <td>{c.reason}</td>
                        <td><center>{dateAndTime}</center></td>
                      </tr>
                    </tbody>
                  )
                })
              }
            </table>
          </DialogContent>
          <DialogActions>
            <Button color='primary' variant='outlined' onClick={ () => { this.setState({ open: false }) }}>Close</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);